import { theme, Col, Card, Button, Row, Typography, Input, Form, Select, Modal } from "antd";
import React, { useState } from "react";
import ImgIcon from "../../../../../view/img-icon";
import { EnquiryRes } from "../../../../../response/enquiry.response";
import { useEnquiry } from "../../../enquiry.hook";
import { handleFilter } from "../../../../../view/input.helper";
import { LargeStatus } from "../../../../../model/large-status.model";
import { EnquiryRequest } from "../../../../../request/enquiry.request";
import { EnquiryService } from "../../../../../service/enquiry.service";
import { AddEnquiryLeadComponent } from "../../add-lead.component";

export interface EnquiryStatusProp {
    enquiry: EnquiryRes
}


export const EnquiryStatus = (props: EnquiryStatusProp) => {

    const { enquiry } = props

    const { useToken } = theme;
    const { token } = useToken();
    const [form] = Form.useForm()

    const [isEdit, setIsEdit] = useState(false);
    const status = Form.useWatch('status', form);
    const { statusList, rejectResonList, fetchEnquiry, updateLoading } = useEnquiry()
    const [createLead, setCreateLead] = useState(false)

    const handleDetailEdit = () => {
        setIsEdit(true)
    }

    const { confirm } = Modal;

    const showConfirmationModal = () => {
        confirm({
            title: 'Are you sure, you want to save changes',
            okText: 'Yes',
            cancelText: 'No',
            onOk() {
                handleOk()
            },
            onCancel() {

            },
        });
    };

    const handleOk = () => {
        form.validateFields().then(async values => {
            const enquiryRequest = {
                status: {
                    value: values["status"],
                    note: values["reason"],
                    description: values["note"],
                    dateTime: new Date()
                } as LargeStatus
            } as EnquiryRequest

            updateLoading(true)

            const [data, error] = await EnquiryService.updateEnquiry(enquiry.id, enquiryRequest)

            if (error) {
                onFailure()
            } else {
                onSuccess()
            }
        });
    };

    const onSuccess = async () => {
        form.resetFields()
        await fetchEnquiry(enquiry.id, () => { updateLoading(false) }, () => { updateLoading(false) })
    }

    const onFailure = () => {
        fetchEnquiry(enquiry.id, () => { }, () => { })
    }

    const onLeadSuccess = async () => {
        await fetchEnquiry(enquiry.id, () => { updateLoading(false) }, () => { updateLoading(false) })
    }

    return (
        <React.Fragment>
            <Col lg={12} xs={24}>
                <Card title="Enquiry Status" bordered={false}
                    extra={(!isEdit && enquiry.status.value == 'Pending' || enquiry.status.value == 'In Progress') &&
                        <Button style={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '0',
                            background: '#E0EEF7',
                            color: '#000000'
                        }}
                            onClick={handleDetailEdit}
                        >
                            <ImgIcon iconName="edit.svg" />
                            Edit
                        </Button>
                    }
                    style={{
                        padding: '0 20px',
                    }}
                    headStyle={{
                        padding: 0
                    }}
                    bodyStyle={{
                        padding: '15px 0'
                    }}
                    className="enquiry-professional-details wrapper-class common-space"
                >

                    {isEdit &&
                        <Form form={form}>

                            {(enquiry.status.value === 'Pending' || enquiry.status.value === 'In Progress') &&
                                <>
                                    <Row style={{
                                        marginBottom: '20px'
                                    }}>
                                        <Col md={12} xs={24}>
                                            <Typography.Title level={5} style={{
                                                fontSize: '14px'
                                            }}>Status</Typography.Title>
                                            <Form.Item
                                                style={{
                                                    margin: 0
                                                }}
                                                name="status"
                                                label=""
                                                rules={[{ required: true, message: 'Please select status' }]}
                                                initialValue={enquiry.status.value}
                                            >
                                                <Select
                                                    showSearch={true}
                                                    placeholder="Select Type"
                                                    className="form-custom-select"
                                                    style={{
                                                        width: '94%',
                                                        border: '1px solid #92B5D7',
                                                        borderRadius: token.borderRadius,
                                                        boxShadow: 'none'
                                                    }}
                                                    options={statusList}
                                                    filterOption={handleFilter}
                                                />
                                            </Form.Item>

                                        </Col>
                                        {(status && rejectResonList[status] && rejectResonList[status].length > 0) && (
                                            <Col md={12} xs={24}>
                                                <Typography.Title level={5} style={{
                                                    fontSize: '14px'
                                                }}>Reason</Typography.Title>

                                                <Form.Item
                                                    name="reason"
                                                    rules={[{ required: true, message: 'Please input your username!' }]}
                                                >
                                                    <Select
                                                        showSearch={true}
                                                        placeholder="Select Type"
                                                        className="form-custom-select"
                                                        style={{
                                                            width: '98%',
                                                            border: '1px solid #92B5D7',
                                                            borderRadius: token.borderRadius,
                                                            boxShadow: 'none'
                                                        }}
                                                        options={rejectResonList[status]}
                                                        filterOption={handleFilter}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        )}
                                    </Row>
                                    <Row style={{
                                        marginBottom: '20px'
                                    }}>
                                        <Col xs={24}>
                                            <Typography.Title level={5} style={{
                                                fontSize: '14px'
                                            }}>Note</Typography.Title>
                                            <Form.Item
                                                name="note"
                                                style={{
                                                    margin: 0
                                                }}
                                                rules={[{ required: false }]}
                                                initialValue={""}
                                            >
                                                <Input
                                                    type="text"
                                                    placeholder="Type here"
                                                    style={{
                                                        width: '100%',
                                                        border: '1px solid #92B5D7',
                                                        borderRadius: token.borderRadius,
                                                        boxShadow: 'none'
                                                    }}
                                                />
                                            </Form.Item>

                                        </Col>
                                    </Row>
                                </>

                            }

                            <Row className="action-row" style={{
                                justifyContent: 'end'
                            }}>
                                <Col style={{ marginRight: 16 }}>
                                    <Button style={{
                                        border: '0',
                                        background: '#E0EEF7',
                                        color: '#000000'
                                    }}
                                        onClick={() => setIsEdit(false)}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                                <Col>
                                    {(status !== "Closed") ?
                                        <Button type="primary" block style={{
                                            background: token.colorInfo,
                                            boxShadow: 'none'
                                        }}
                                            onClick={showConfirmationModal}
                                        >
                                            Save Changes
                                        </Button> :
                                        <Button type="primary" block style={{
                                            background: token.colorInfo,
                                            boxShadow: 'none'
                                        }}
                                            onClick={() => { setCreateLead(true) }}
                                        >
                                            Create Lead
                                        </Button>
                                    }
                                </Col>
                            </Row>
                        </Form>
                    }

                    {!isEdit &&
                        <React.Fragment>
                            <Row style={{
                                marginBottom: '20px'
                            }}>
                                <Col md={12} xs={24}>
                                    <Typography.Title level={5} style={{
                                        fontSize: '14px',
                                        margin: 0
                                    }}>Status</Typography.Title>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <ImgIcon iconName="close.svg" />
                                        {enquiry.status.value} | {enquiry.status.note} | {enquiry.status.description}
                                    </div>
                                </Col>
                            </Row>

                        </React.Fragment>
                    }
                </Card>

                {createLead &&
                    <AddEnquiryLeadComponent enquiry={enquiry} open={true} onCancel={() => { setCreateLead(false) }} onLeadSuccess={onLeadSuccess} />
                }

            </Col>
        </React.Fragment>
    )
}